export default "__VITE_ASSET__9ce9aacd__"